export default "__VITE_ASSET__r$So1a$6__$_?assetResource__"